import { ReactNode } from 'react';
import { ProductItem } from '../../types/api';
import { selectQuantity, useCartStore } from '../../store/cartStore';
import QuantityStepper from '../QuantityStepper/QuantityStepper';

interface Props {
  readonly product: Pick<ProductItem, 'item_id' | 'price' | 'description' | 'image_url'>;
  readonly disabled?: boolean;
  /** Sold out: show why it can't be added, unless the item is already in the bag. */
  readonly soldOut?: boolean;
  /** Shown instead of the disabled "Sold out" button, e.g. "Notify me". */
  readonly soldOutAction?: ReactNode;
  readonly buttonClassName: string;
  readonly stepperClassName: string;
}

/** "Add to Cart" until the product is in the cart, then a quantity stepper. */
export default function AddToCartControl({
  product,
  disabled,
  soldOut,
  soldOutAction,
  buttonClassName,
  stepperClassName,
}: Props) {
  const quantity = useCartStore(selectQuantity(product.item_id));
  const addItem = useCartStore((s) => s.addItem);
  const increment = useCartStore((s) => s.increment);
  const decrement = useCartStore((s) => s.decrement);
  if (quantity === 0 && soldOut) {
    if (soldOutAction) return <>{soldOutAction}</>;
    return (
      <button className={buttonClassName} disabled>
        Sold out
      </button>
    );
  }
  if (quantity === 0) {
    return (
      <button className={buttonClassName} disabled={disabled} onClick={() => addItem(product)}>
        Add to Cart
      </button>
    );
  }
  return (
    <div className={stepperClassName}>
      <QuantityStepper
        quantity={quantity}
        onIncrement={() => increment(product.item_id)}
        onDecrement={() => decrement(product.item_id)}
      />
    </div>
  );
}
